import React, { FC, ReactNode } from "react";

const SectionWithTitle: FC<{ title: ReactNode; className?: string }> = ({
  title,
  children,
  className = "",
}) => (
  <div className={`section-with-title ${className}`}>
    <div className="section-title">{title}</div>
    <div>{children}</div>
  </div>
);

export default SectionWithTitle;
